import { useEffect } from 'react'

export const toggleBodyOverflow = (isOpen: boolean): void => {
  document.body.style.overflow = isOpen ? 'hidden' : 'unset'
}

export const useBodyOverflow = (openedModalId: string) => {
  useEffect(() => {
    toggleBodyOverflow(!!openedModalId)
  }, [openedModalId])

  useEffect(() => {
    // clean overflow state on unmount
    return () => {
      toggleBodyOverflow(false)
    }
  }, [])
}
